import React from "react"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ModalNames } from "features/modals/types"
import { useAppDispatch } from "integrations/redux/hooks"
import { usePluginState } from "../../usePluginState"
import { ButtonTertiary } from "@nova/component-btn"
import { hideGlobalModal } from "runlevel/actions"
import { useFeatureFlag } from "features/feature-flags/useFeatureFlag"
import { config } from "@nova/configuration/browser"

export const ChooseLiveVideoTypeModal = () => {
    const { setSelectedPlugin } = usePluginState()
    const dispatch = useAppDispatch()
    const hasSkydioLiveStream = !!useFeatureFlag("skydioLiveStream")
    const hasSpurLivestream = !!config.use("hasSpurLivestream").hasSpurLivestream
    const hasOdfLivestream = !!config.use("hasOdfLivestream").hasOdfLivestream
    const maybeStreams = +hasSkydioLiveStream + +hasSpurLivestream + +hasOdfLivestream
    const lastColWidth = (maybeStreams % 2) + 1

    const optionClasses =
        "bg-white-100 border border-white-200 hover:border-white-400 active:border-white-300 rounded-md p-4 flex cursor-pointer select-none"
    return (
        <HighPriorityNovaModalContainer
            title="Start a Live Stream"
            className="w-[38rem]"
            canCloseModal
            closeModal={() => {
                dispatch(hideGlobalModal())
                setSelectedPlugin(undefined)
            }}
            bottomBar={
                <ButtonTertiary
                    title="Close"
                    className="ml-auto"
                    onClick={() => {
                        dispatch(hideGlobalModal())
                        setSelectedPlugin(undefined)
                    }}
                />
            }
        >
            <div className="grid grid-cols-2 gap-3 mt-8">
                {hasSpurLivestream && (
                    <div
                        className={`${optionClasses} flex-col items-center `}
                        onClick={() =>
                            dispatch(
                                initializeCenterModalForComponentAction(
                                    ModalNames.FlirMmaLiveStreamModal
                                )
                            )
                        }
                    >
                        <div className="h-[5.375rem] flex items-center justify-center w-full">
                            <img
                                src="/images/live-video-spur.png"
                                alt="Spur Aviation Logo"
                                draggable={false}
                                className="w-full h-auto"
                            />
                        </div>

                        <small className="xs text-gray-400 self-start mt-2">VIA</small>
                        <h3 className="text-gray-0 self-start">Spur Aviation</h3>
                    </div>
                )}
                {hasOdfLivestream && (
                    <div
                        className={`${optionClasses} flex-col items-center `}
                        onClick={() =>
                            dispatch(
                                initializeCenterModalForComponentAction(
                                    ModalNames.FlirMmaLiveStreamModal
                                )
                            )
                        }
                    >
                        <div className="h-[5.375rem] flex items-center justify-center w-full">
                            <img
                                src="/images/live-video-oregon-df.png"
                                alt="Oregon Department of Forestry Logo"
                                draggable={false}
                                className="h-full w-auto"
                            />
                        </div>

                        <small className="xs text-gray-400 self-start mt-2">VIA</small>
                        <h3 className="text-gray-0 self-start">OR Department of Forestry</h3>
                    </div>
                )}
                <div
                    className={`${optionClasses} flex-col items-center `}
                    onClick={() =>
                        dispatch(
                            initializeCenterModalForComponentAction(
                                ModalNames.DjiEnterpriseOcaModal
                            )
                        )
                    }
                >
                    <div className="h-[5.375rem] flex items-center justify-center w-full">
                        <img
                            src="/images/live-video-dji-enterprise.png"
                            alt="DJI Enterprise Controller"
                            draggable={false}
                            className="h-full w-auto"
                        />
                    </div>

                    <small className="xs text-gray-400 self-start mt-2">VIA</small>
                    <h3 className="text-gray-0 self-start">DJI Enterprise Controller</h3>
                </div>
                {hasSkydioLiveStream && (
                    <div
                        className={`${optionClasses} flex-col items-center`}
                        onClick={() =>
                            dispatch(
                                initializeCenterModalForComponentAction(
                                    ModalNames.SkydioLiveStreamModal
                                )
                            )
                        }
                    >
                        <div className="h-[5.375rem] flex items-center justify-center w-full">
                            <img
                                src="/images/live-video-skydio.png"
                                alt="Skydio Drones"
                                draggable={false}
                                className="h-full w-auto"
                            />
                        </div>

                        <small className="xs text-gray-400 self-start mt-2">VIA</small>
                        <h3 className="text-gray-0 self-start">Skydio Controllers</h3>
                    </div>
                )}
                <div
                    className={`${optionClasses} flex-col items-center`}
                    style={{ gridColumn: `span ${lastColWidth} / span ${lastColWidth}` }}
                    onClick={() =>
                        dispatch(
                            initializeCenterModalForComponentAction(ModalNames.LiveVideoMobileModal)
                        )
                    }
                >
                    <div className="h-[5.375rem] flex items-center justify-center px-16">
                        <img
                            src="/images/live-video-other.png"
                            alt="Other Drone Controllers or Mobile Devices"
                            draggable={false}
                            className="max-h-full w-auto"
                        />
                    </div>

                    <div>
                        <small className="xs text-gray-400 self-start mt-2">VIA</small>
                        <h3 className="text-gray-0 self-start">Other controllers or phones</h3>
                    </div>
                </div>
            </div>
        </HighPriorityNovaModalContainer>
    )
}
